export default __webpack_public_path__ + "static/media/Bar - Voids & Replacements.224b65bd.png";